import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import useCheckoutState from '../hooks/use-checkout-state.js';

const CheckoutContext = createContext({});
const CheckoutContextProvider = ({ children, onError }) => {
    const api = useCheckoutState({ onError });
    const parentContext = useContext(CheckoutContext);
    if (parentContext && Object.keys(parentContext).length > 0) {
        onError &&
            onError('You cannot initialize the checkout state provider as it is already initialized');
        return null;
    }
    return jsx(CheckoutContext.Provider, { value: api, children: children });
};

export { CheckoutContext, CheckoutContextProvider };
//# sourceMappingURL=checkout-context.js.map
